/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedLetterH = createReactComponent(
  "square-rounded-letter-h",
  "IconSquareRoundedLetterH",
  [
    ["path", { d: "M10 16v-8m4 0v8", key: "svg-0" }],
    ["path", { d: "M10 12h4", key: "svg-1" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-2"
      }
    ]
  ]
);

export { IconSquareRoundedLetterH as default };
//# sourceMappingURL=IconSquareRoundedLetterH.js.map
